// import { Col, Row, Select, Table, Spin, message } from "antd";
// import React, { useEffect, useState } from "react";
// import dataService from "../networks/api/service/dataService";
// import { useLocation } from "react-router-dom";

// const { Option } = Select;

// function ConstituencyBriefDetails() {
//   const location = useLocation();

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [tableData, setTableData] = useState([]);

//   const { selectedAssembly, year, electionType } = location.state || {};
//   console.log(
//     selectedAssembly,
//     year,
//     electionType,
//     "selectedAssembly, year, electionType"
//   );
//   // Flatten the nested response structure
//   const flattenResponse = (response) => {
//     if (response.data) {
//       const { electionDetails, position, votePercentage } = response.data;

//       // Combine the nested objects into one flat object
//       return {
//         ...electionDetails,
//         ...position,
//         ...votePercentage,
//       };
//     }
//     return {};
//   };

//   // Transform the data for Y-axis headers and X-axis values
//   const transformToTransposedData = (data, year) => {
//     const transposedData = Object.entries(data).map(([key, value]) => ({
//       header: key
//         .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase to words
//         .replace(/_/g, " ") // Replace underscores with spaces
//         .toUpperCase(),
//       value: value !== null ? value : "-", // Handle null values gracefully
//     }));

//     return transposedData;
//   };

//   // Fetch data and process it
//   const fetchConstituencyData = async () => {
//     setLoading(true);
//     try {
//       let response;
//       if (electionType === "AC") {
//         response = await dataService.getConstElectionAc(selectedAssembly, year);
//       } else if (electionType === "PC") {
//         response = await dataService.getConstElectionPc(selectedAssembly, year);
//       }

//       if (response && response.data) {
//         const flattenedData = flattenResponse(response);
//         const transposedData = transformToTransposedData(flattenedData, year);
//         setTableData(transposedData);
//       } else {
//         message.error("No data available for the selected criteria.");
//       }
//     } catch (error) {
//       console.error(error);
//       message.error("Error fetching data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedAssembly && year && electionType) {
//       fetchConstituencyData();
//     }
//   }, [selectedAssembly, year, electionType]);

//   // Table columns for transposed data
//   const transposedColumns = [
//     {
//       title: "HEADER",
//       dataIndex: "header",
//       key: "header",
//       width: "50%",
//     },
//     {
//       title: year || "VALUE", // Display selected year as column title
//       dataIndex: "value",
//       key: "value",
//       width: "50%",
//     },
//   ];

//   return (
//     <div style={{ padding: "20px" }}>
//       {loading ? (
//         <Spin size="large" style={{ display: "block", marginTop: "20px" }} />
//       ) : (
//         <Table
//           columns={transposedColumns}
//           dataSource={tableData}
//           rowKey={(record, index) => index}
//           pagination={false}
//           style={{ marginTop: "20px" }}
//         />
//       )}
//     </div>
//   );
// }

// export default ConstituencyBriefDetails;
import { Col, Row, Select, Table, Spin, message } from "antd";
import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { useLocation } from "react-router-dom";

const { Option } = Select;

function ConstituencyBriefDetails() {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { selectedAssembly, year, electionType } = location.state || {};
  console.log(
    selectedAssembly,
    year,
    electionType,
    "selectedAssembly, year, electionType"
  );

  // Flatten the nested response structure
  const flattenResponse = (response) => {
    if (response.data) {
      const { electionDetails, position, votePercentage } = response.data;
      return {
        ...electionDetails,
        ...position,
        ...votePercentage,
      };
    }
    return {};
  };

  // Transform the data for Y-axis headers and X-axis values
  const transformToTransposedData = (data, year) => {
    const transposedData = Object.entries(data).map(([key, value]) => ({
      header: key, // Original header
      displayHeader: key
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase to words
        .replace(/_/g, " ") // Replace underscores with spaces
        .toUpperCase(),
      value: value !== null ? value : "-", // Handle null values gracefully
    }));
    return transposedData;
  };

  // Fetch data and process it
  const fetchConstituencyData = async () => {
    setLoading(true);
    try {
      let response;
      if (electionType === "AC") {
        response = await dataService.getConstElectionAc(selectedAssembly, year);
      } else if (electionType === "PC") {
        response = await dataService.getConstElectionPc(selectedAssembly, year);
      }

      if (response && response.data) {
      } else {
        message.error("No data available for the selected criteria.");
      }
    } catch (error) {
      console.error(error);
      message.error("Error fetching data.");
    } finally {
      setLoading(false);
    }
  };

  // Handle row click to fetch analysis data
  const handleRowClick = async (record) => {
    const { header } = record;

    // Only proceed if the header matches specific criteria
    if (
      ["above45", "thirtyTo45", "below30", "first", "second", "third"].includes(
        header
      )
    ) {
      const position = ["first", "second", "third"].includes(header)
        ? header
        : null;
      const votePercentage = ["above45", "thirtyTo45", "below30"].includes(
        header
      )
        ? header
        : null;

      setLoading(true);
      try {
        let response;
        if (electionType === "AC") {
          response = await dataService.getConstAnalysisAc(
            selectedAssembly,
            year,
            votePercentage,
            position
          );
        } else if (electionType === "PC") {
          response = await dataService.getConstAnalysisPc(
            selectedAssembly,
            year,
            votePercentage,
            position
          );
        }

        if (response && response.data) {
          const flattenedData = flattenResponse(response);
          const transposedData = transformToTransposedData(flattenedData, year);
          setTableData(transposedData); // Update the table with new data
        } else {
          message.error("No data available for the selected criteria.");
        }
      } catch (error) {
        console.error(error);
        message.error("Error fetching data.");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (selectedAssembly && year && electionType) {
      fetchConstituencyData();
    }
  }, [selectedAssembly, year, electionType]);

  // Table columns for transposed data
  const transposedColumns = [
    {
      title: "HEADER",
      dataIndex: "displayHeader", // Display transformed header text
      key: "displayHeader",
      width: "50%",
    },
    {
      title: year || "VALUE", // Display selected year as column title
      dataIndex: "value",
      key: "value",
      width: "50%",
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <Spin size="large" style={{ display: "block", marginTop: "20px" }} />
      ) : (
        <Table
          columns={transposedColumns}
          dataSource={tableData}
          rowKey={(record, index) => index}
          pagination={false}
          style={{ marginTop: "20px" }}
          onRow={(record) => ({
            onClick: () => handleRowClick(record), // Handle row clicks
          })}
        />
      )}
    </div>
  );
}

export default ConstituencyBriefDetails;
